import * as React from 'react';
import { BrandListItem, BrandList as BrandList$1, BrandListGroup } from '@grandvisionhq/content';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import { groupBrands } from '../../utils/group-brands.js';
import '../../utils/http-client.js';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBloomreachPageable } from '../../hocs/with-bloomreach-pageable.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsBrandListItem = withEditableContent(({ content  })=>{
    var _url;
    const [link] = useBloomreachLinks([
        {
            url: (_url = content.url) !== null && _url !== void 0 ? _url : '#'
        }
    ]);
    return /*#__PURE__*/ React.createElement(BrandListItem, {
        url: link.url
    }, content.title);
});
const CmsBrandList = ({ content , meta , template  })=>{
    const { locale  } = useIntl();
    switch(template){
        case 'brand-list':
            const groups = groupBrands(content.items, 4, locale);
            return /*#__PURE__*/ React.createElement(BrandList$1, {
                title: String(meta.title)
            }, groups.map(({ title , items  }, i)=>/*#__PURE__*/ React.createElement(BrandListGroup, {
                    title: title,
                    key: i
                }, items.map((brand)=>/*#__PURE__*/ React.createElement(CmsBrandListItem, {
                        content: brand,
                        key: brand.id
                    })
                ))
            ));
        default:
            return /*#__PURE__*/ React.createElement(Heading, {
                variant: "subheading1"
            }, "Banner of type ", template, " not defined in BrandList");
    }
};
var BrandList = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withAnchor)(CmsBrandList);

export { CmsBrandList, BrandList as default };
//# sourceMappingURL=BrandList.js.map
